import { useAtomValue } from 'jotai';
import { useRouter } from 'next/router';
import { MouseEvent, useMemo } from 'react';
import { useToast } from '@pairy/pds-react';

import { UploadingFileInfoListAtom } from '@/state/file/uploadingfile.atom';

const useCheckUpdatingFile = () => {
  const router = useRouter();
  const { fileId } = router.query;

  const toast = useToast();

  const updatingFileIdList = useAtomValue(UploadingFileInfoListAtom);

  const isActionDisabledFile = useMemo(() => {
    return (
      typeof updatingFileIdList?.find(
        ({ id }) => Number(id) === Number(fileId),
      ) !== 'undefined'
    );
  }, [fileId, updatingFileIdList]);

  const handleDisabledButtonClick = (
    e?: MouseEvent<HTMLDivElement | HTMLButtonElement>,
  ) => {
    if (isActionDisabledFile) {
      if (e) {
        e.stopPropagation();
        e.preventDefault();
      }
      toast.error('파일 수정중에는 불가능합니다');
      return;
    }
  };

  return {
    isDisabled: isActionDisabledFile,
    handleDisabledButtonClick,
  };
};

export default useCheckUpdatingFile;
